import { useState, useEffect, useRef } from 'react';
import { Defect } from '../types';
import { isEqual } from 'lodash';

const useDefectLinkManager = (initialDefects: Defect[] = []) => {
    const [defectsArrLocal, setDefectsArrLocal] = useState<Defect[]>(initialDefects);
    const [defectsToToggleLink, setDefectsToToggleLink] = useState<Defect['pk'][]>([]);
    const hasDefectChanges = defectsToToggleLink.length > 0;

    const initialDefectsRef = useRef(initialDefects);

    useEffect(() => {
        if (!isEqual(initialDefectsRef.current, initialDefects)) {
            initialDefectsRef.current = initialDefects;
            setDefectsArrLocal(initialDefects);
        }
    }, [initialDefects]);

    const handleLinkDefect = (defect: Defect) => {
        setDefectsArrLocal((prev) => [defect, ...prev]);
        setDefectsToToggleLink((prev) => [...prev, defect.pk]);
    };

    const handleUnlinkDefect = (defectId: Defect['pk']) => () => {
        setDefectsArrLocal((prev) => prev.filter((d) => d.pk !== defectId));
        setDefectsToToggleLink((prev) => [...prev, defectId]);
    };

    const resetDefectChanges = () => {
        setDefectsArrLocal(initialDefects);
        setDefectsToToggleLink([]);
    };

    return {
        defectsArrLocal,
        defectsToToggleLink,
        handleLinkDefect,
        handleUnlinkDefect,
        resetDefectChanges,
        hasDefectChanges,
    };
};

export default useDefectLinkManager;
